import { useMemo } from "react";
import CustomForm from "../../common/components/CustomForm";
import { Container } from "../../common/components/Grid";
import { useEpcrEditorEpcr, useEpcrEditorIntent } from "./EpcrContext";
import PropTypes from 'prop-types';
import { customCtrlTypeSupported } from "../../common/components/DataTable";
import { deepClone } from "../../common/utils/objectUtilities";

const EpcrCustomPanel = ({ formdef, disabled = false }) => {
    const { epcr, update } = useEpcrEditorEpcr();
    const intent = useEpcrEditorIntent();

    const runUpdate = (value) => {
        update('customfields', value);
    }

    const def = useMemo(() => {
        if (intent === 'search') {
            let def = deepClone(formdef);
            def.forEach(section => {
                section.rows = section.rows.map(row => row.filter(cell => customCtrlTypeSupported(cell)));
                section.rows = section.rows.filter(row => row.length > 0);
            });
            def = def.filter(section => section.rows.length > 0);
            return def;
        }
        return formdef;
    }, [intent, formdef]);

    return <Container fluid>
        <CustomForm disabled={disabled} hideLabel={true} def={def} data={epcr?.customfields ?? {}} onChange={runUpdate}></CustomForm>
    </Container>
}

EpcrCustomPanel.propTypes = {
    formdef: PropTypes.object.isRequired,
    disabled: PropTypes.bool
}

export default EpcrCustomPanel;